import * as React from 'react'
import { useDispatch } from 'react-redux'
import ExternalIntegrationsApiService, { ExternalCityMappingModel, ExternalCityMappingPostModel } from '../../services/ExternalIntegrationsApiService'
import CitiesApiService from '../../services/CitiesApiService'
import { DataTable, DataTableColumnModel, DataTableModel, defaultLabelSort, FilterType, InputType, SelectOptionModel } from 'traveldesk-ui'
interface Props {
    apiProviderId: number | undefined
}

const AdminExternalCitiesMappings = (props: Props) => {
    const dispatch = useDispatch()
    const [citiesOptions, setCitiesOptions] = React.useState<SelectOptionModel[]>([])
    const [externalCities, setExternalCities] = React.useState<ExternalCityMappingModel[]>([])
    const citiesHash = React.useMemo(() => {
        return citiesOptions.reduce((acc, curr) => {
            acc.set(curr.value as number, curr.label)
            return acc
        }, new Map<number, string>())
    }, [citiesOptions])
    React.useEffect(() => {
        loadCitiesOptions()
    }, [])
    React.useEffect(() => {
        if (props.apiProviderId) {
            getCities()
        }
    }, [props.apiProviderId])
    const loadCitiesOptions = async () => {
        const res = await CitiesApiService.GetCitiesOfOperation(dispatch)
        if (res.IsOk && res.Content) {
            setCitiesOptions(res.Content
                .map(c => ({ label: `${c.name} (${c.countryName})`, value: c.id } as SelectOptionModel))
                .sort(defaultLabelSort)
            )
        }
    }
    const getCities = async () => {
        if (props.apiProviderId) {
            const citiesResponse = await ExternalIntegrationsApiService.getExternalCitiesMappings(dispatch, props.apiProviderId.toString())
            if (citiesResponse.IsOk && citiesResponse.Content) {
                setExternalCities(citiesResponse.Content)
            }
        }
    }
    const initDataTable = () => {
        const columns = [
            new DataTableColumnModel({
                displayName: 'API Integration City',
                fieldName: 'apiIntegrationCityName',
                filterType: FilterType.TEXT,
            }),
            new DataTableColumnModel({
                displayName: 'Our City',
                fieldName: 'ourCityId',
                isEditable: true,
                editType: InputType.Select,
                editOptions: citiesOptions,
                filterType: FilterType.SELECT,
                filterOptions: citiesOptions,
                isClearable: true,
                customRenderer: (obj: ExternalCityMappingModel) => obj.ourCityId ? citiesHash.get(obj.ourCityId as number) : ''
            })
        ]
        return new DataTableModel({
            columns,
            name: 'Cities Mappings',
        })
    }
    const onSetMapping = async (prevObj: ExternalCityMappingModel, obj: ExternalCityMappingModel) => {
        if (prevObj.ourCityId !== obj.ourCityId) {
            const payload = { apiProviderId: props.apiProviderId as number, cityId: obj.ourCityId, externalCityId: obj.apiIntegrationCityId } as ExternalCityMappingPostModel
            const response = await ExternalIntegrationsApiService.saveExternalCitiesMapping(dispatch, payload)
            if (response.IsOk && response.Content) {
                setExternalCities(prevCities => prevCities.map(city => city.apiIntegrationCityId === obj.apiIntegrationCityId ? response.Content ?? city : city))
            }
        }
    }
    const onRefreshData = async () => {
        await getCities()
    }
    return <DataTable
        data={externalCities}
        dataTable={initDataTable()}
        onRefreshData={onRefreshData}
        isFullScreen
        fixedHeight={600}
        onEdit={onSetMapping} />
}
export default AdminExternalCitiesMappings
